import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/utils/rem.js'
import './assets/fonts/TheFont.css'

import message from '../common/message.js'
import store from '../common/store.js'
import http from '../common/http'

Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.prototype.http = http;
Vue.prototype.store = store;
Vue.prototype.message = message;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
